import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProfileResponse, ImageUploadResponse, AuthoriseGrantResponse } from 'sharedweb/app.interface';
import { applicationUrls } from 'sharedweb/helpers/urls';
import { map } from 'rxjs/operators';
import { OauthClientDetails } from './oauth.interface';
import { Utils } from 'src/app/_helpers';

@Injectable({
    providedIn: 'root'
})
export class AccountsService {

    private _profileResponse: ProfileResponse;
    private _profileResponseRequest: Promise<ProfileResponse>;
    imageLink = '';

    constructor(
        private httpClient: HttpClient,
    ) { }

    fetchProfile(): Promise<ProfileResponse> {
        if (this._profileResponse === undefined) {
            if (this._profileResponseRequest) {
                return this._profileResponseRequest;
            } else {
                const url = applicationUrls.userProfile;
                this._profileResponseRequest = new Promise((resolve, reject) => {
                    this.httpClient.get<ProfileResponse>(url).subscribe(
                        (res) => {
                            if (res.image) {
                                // Adding timestamp as a cache breaker.
                                res.image = `${applicationUrls.profileImage}${res.image}?r=${new Date().getTime().toString()}&token=${Utils.storageHelper.userInfo.access_token}`;
                            }
                            this.imageLink = res.image;
                            // showing first name initials always for profile and dashboard page
                            if (res.first_name && res.first_name.length) {
                                res['initials'] = res.first_name[0].toUpperCase();
                            } else {
                                res['initials'] = '';
                            }
                            this._profileResponse = res;
                            resolve(this._profileResponse);
                        }, (err) => {
                            reject(err);
                        });
                });
                return this._profileResponseRequest;
            }

        } else {
            return new Promise(resolve => resolve(this._profileResponse));
        }
    }

    uploadProfileImage(image: any) {
        const formData = new FormData();
        formData.append('image', image);
        return this.httpClient.post<ImageUploadResponse>(applicationUrls.userProfile, formData).pipe(
            map((res) => {
                if (res.image_name) {
                    // Adding timestamp as a cache breaker.
                    res.image_name = `${applicationUrls.profileImage}${res.image_name}?r=${new Date().getTime().toString()}&token=${Utils.storageHelper.userInfo.access_token}`;
                }
                this.imageLink = res.image_name;
                return res;
            })
        );
    }

    getGrantDetails(oauthReq: any) {
        return this.httpClient.get<OauthClientDetails>(applicationUrls.oauthGrant, {
            params: oauthReq
        })
    }

    authoriseGrantDetails(oauthReq: any) {
        return this.httpClient.post<AuthoriseGrantResponse>(applicationUrls.oauthGrant, oauthReq, {
            params: oauthReq
        })
    }
}
